import axios from 'axios';
import domainByEnv from './domainByEnv';

interface I_HandleFavorite {
    isLogin: boolean;
    isFavorite: boolean;
    TravelType: string | number;
    TagList: string; // 不確定能不能取代TravelType用
    Price: string | number;
    ProductID: string;
    ProductName: string;
    ProductURL: string;
    GoDate?: string; // 團體館 需要顯示出發日期用
    AirportCabin?: string; //機票館的艙等
}

interface I_FavData {
    ProductList: I_FavItem[];
}

interface I_FavItem {
    TravelType: string; // 旅遊型態
    ProductID: string; // GroupID
    NormGroupID: string; // 標準團名
    Price: number; // 價格
    Days: number; // 天數
}

export const handleFavorite = async ({
    isLogin,
    isFavorite,
    TravelType,
    ProductID,
    ProductName,
    ProductURL,
    Price,
    GoDate,
    AirportCabin,
}: I_HandleFavorite) => {
    if (isLogin) {
        try {
            // 若已收藏，刪除收藏；若未收藏，加入收藏
            // const payload = isFavorite ? deletePayload : insertPayload;
            const api = isFavorite ? 'deletefavorite' : 'insertfavorite';
            ProductURL = ProductURL.replace(/&/gi, '%26');
            const insertQueryString = JSON.stringify({
                traveltype: TravelType,
                productname: ProductName,
                productid: ProductID,
                Price: Price,
                departuredate: GoDate,
                Href: ProductURL,
                name: 'Favorite',
                airportCabin: AirportCabin
            });

            const deleteQueryString = `{"traveltype":${TravelType},"productid":"${ProductID}","name":"Favorite"}`;
            const queryString = isFavorite ? deleteQueryString : insertQueryString;

            const res = await fetch(
                `${domainByEnv()}/common/common/${api}?jsonStr=${queryString}`,
                {
                    method: 'POST',
                }
            );

            const isDeleteOrInsertSuccess = await res.json(); //true false操作成功或失敗

            // 若先從sidebar移除收藏，再到頁面點掉愛心，會因為列表沒有該收藏而卡住
            // 此時檢查收藏列表，若不在列表則回傳true，讓後續動作可以繼續執行
            if (isFavorite && !isDeleteOrInsertSuccess) {
                const favList = await getIsFavorite(0);
                const isInFavList = favList.find((favItem) => favItem.ProductID === ProductID);
                return !isInFavList;
            } else {
                return isDeleteOrInsertSuccess;
            }
        } catch (err) {
            console.log('收藏error =>', err);
            return false;
        }
    } else {
        sessionStorage.setItem('waitedForAddedFav', ProductID || '');
        // 開啟登入光箱
        window.Templates.login_lion.default.OpenLogin();
        return false;
    }
};

// 0 : 搜尋結果頁用，for 團體 + 團體自由行
export const getIsFavorite = async (TravelType: string | number) => {
    const { data }: { data: I_FavData } = await axios.get(
        `${domainByEnv()}/common/common/getfavoritebytype?type=${TravelType}`
    );

    return data.ProductList ? data.ProductList : [];
};
